module.exports = __webpack_public_path__ + "img/rep_cost.77643378.png";